import { render, staticRenderFns } from "./RecoverFirebaseView.vue?vue&type=template&id=f1ba6926&"
import script from "./RecoverFirebaseView.vue?vue&type=script&lang=ts&"
export * from "./RecoverFirebaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports